import promiseFinally from 'promise.prototype.finally';

import 'taker/index.scss';
import takerStore from 'taker/takerStore';
import Routes from 'taker/Routes';
import renderApp from '../renderApp';
import initSentry from '../initSentry';

promiseFinally.shim();

initSentry(); // Sentry should be initiated before first app render @sinslav

renderApp(Routes, takerStore);

if (module.hot) {
  module.hot.accept(() => {
    renderApp(Routes, takerStore);
  });
}
